import {
  object, string, date, array,
  bool,
} from 'yup';

import { LISTEDKIT_TYPES } from './listedkit.constants';

const listedkitSchema = object({
  id: string(),
  created_on: date().required(),
  updated_on: date().required(),

  company_id: string().required(),
  milestone_ids: array().of(string()).default([]),
  user_id: string(),

  // deal_id only for transaction listed kits
  deal_id: string().nullable().default(null), // need refactor and remove

  type: string().oneOf(Object.values(LISTEDKIT_TYPES)).required(),
  name: string(),
  is_ghost: bool().required().default(false),
});

export default listedkitSchema;
